"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _jQuery = _interopRequireDefault(require("jQuery"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _UIFormControl = _interopRequireDefault(require("UIComponents/form/UIFormControl"));

var _DynoEditor = require("lead-flows-ui/constants/DynoEditor");

var _RichTextEditor = _interopRequireDefault(require("lead-flows-ui/components/common/RichTextEditor"));

var _ValidationUtils = require("lead-flows-ui/utils/ValidationUtils");

var _RedirectOptions = _interopRequireDefault(require("./dynoThankYouPanel/RedirectOptions"));

var THANKS_MAX_LENGTH = 1000;

var _default = _react.default.createClass({
  displayName: "DynoThankYouPanel",
  propTypes: {
    addValidationError: _react.default.PropTypes.func.isRequired,
    allGates: _react.default.PropTypes.array.isRequired,
    completedMessageHtml: _react.default.PropTypes.string,
    gates: _react.default.PropTypes.object.isRequired,
    redirectButtonType: _react.default.PropTypes.string.isRequired,
    redirectButtonText: _react.default.PropTypes.string,
    removeValidationError: _react.default.PropTypes.func.isRequired,
    updateDyno: _react.default.PropTypes.func.isRequired,
    validation: _react.default.PropTypes.object.isRequired
  },
  getDefaultProps: function getDefaultProps() {
    return {
      validation: {}
    };
  },
  langKey: function langKey(suffix) {
    return "leadFlowEditor.leadFlowThankYouMessage." + suffix;
  },
  addValidationError: function addValidationError(field, message) {
    this.props.addValidationError(field, message, _DynoEditor.STEPS.THANKS);
  },
  removeValidationError: function removeValidationError(field) {
    this.props.removeValidationError(field, _DynoEditor.STEPS.THANKS);
  },
  handleCompletedMessageChange: function handleCompletedMessageChange(value) {
    var updateDyno = this.props.updateDyno;
    updateDyno({
      completedMessageHtml: value.html
    });

    if ((0, _jQuery.default)('<div />').html(value.html).text().length === 0) {
      this.addValidationError('completedMessageHtml', this.langKey('error.thankYouFieldRequired'));
    } else if (value.plainText.length > THANKS_MAX_LENGTH) {
      this.addValidationError('completedMessageHtml', this.langKey('error.thankYouExceedsMaxLength'));
    } else {
      this.removeValidationError('completedMessageHtml');
    }
  },
  render: function render() {
    var _this$props = this.props,
        validation = _this$props.validation,
        completedMessageHtml = _this$props.completedMessageHtml,
        allGates = _this$props.allGates;
    return _react.default.createElement("div", null, _react.default.createElement(_UIFormControl.default, {
      error: validation.completedMessageHtml,
      validationMessage: (0, _ValidationUtils.maybeShowInvalidMessage)(validation.completedMessageHtml),
      label: _react.default.createElement(_FormattedMessage.default, {
        message: this.langKey('thankYouMessageHeader')
      }),
      tooltip: _react.default.createElement(_FormattedMessage.default, {
        message: this.langKey('thankYouMessageTooltip')
      })
    }, _react.default.createElement(_RichTextEditor.default, {
      gates: allGates,
      id: "completed-message-html",
      contents: completedMessageHtml,
      onChange: this.handleCompletedMessageChange
    })), _react.default.createElement(_RedirectOptions.default, {
      allGates: allGates,
      updateDyno: this.props.updateDyno,
      validation: validation,
      addValidationError: this.addValidationError,
      removeValidationError: this.removeValidationError
    }));
  }
});

exports.default = _default;
module.exports = exports.default;